<mat-toolbar style="background-color: #0066cc; color:white">
  <button mat-icon-button (click)="onHomeBtnClick()"><mat-icon>menu</mat-icon></button>
  <span>Automatic Blood Collection System</span>
  
</mat-toolbar>
